<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel class="eca-card">
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px!important ; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;" class="list-page-main-header">
              <span><fa-icon [icon]="['fad', 'users']"> </fa-icon> Details for: {{trainingType.name}} </span>
            </h3>
          </div>
        </div>
      </div>
      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openTrainingRecordDetailsHelp()">
        </app-eca-ghost-btn>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <app-detail-container #ttDetailsContainerComponent [containerHeader]="ttDetailsContainerHeader" [collapsedContainerHeader]="ttDetailsCollapsedContainerHeader"
                                  [containerHeaderAction]="ttDetailsAction">
              <ng-template #ttDetailsContainerHeader>
                Training Course Details
              </ng-template>

              <ng-template #ttDetailsCollapsedContainerHeader>
                Training Course Details
              </ng-template>

              <ng-template #ttDetailsAction>
                <app-eca-ghost-btn class="title-action-button float-right" btnText="Edit" btnIcon="edit"
                                   btnType="primary" [disable]='isTrainingTypeLoading'
                                   *ngIf="!editingDetails"
                                   (btnClicked)="editDetails()"></app-eca-ghost-btn>
                <span class="float-right" *ngIf="editingDetails">
                  <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                                     [disable]='isTrainingTypeLoading' (btnClicked)="saveDetails()"></app-eca-ghost-btn>
                  <app-eca-ghost-btn btnText="Cancel" btnIcon="times" btnType="danger"
                                     [disable]='isTrainingTypeLoading' (btnClicked)="cancelEdit()"></app-eca-ghost-btn>
                </span>
              </ng-template>
              <div *ngIf="isTrainingTypeLoading" class="text-center">
                <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
              </div>
              <div *ngIf="!isTrainingTypeLoading">
                <div class="col">
                  <app-training-type-editor [trainingType]="tempTrainingType" [editingType]="editingDetails"></app-training-type-editor>
                </div>
              </div>
            </app-detail-container>
          </div>
        </div>
      </div>

      <div class="container-fluid" style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
        <div class="row">
          <div class="col">
            <p-tabView #memberTabs [styleClass]="'eca-tabs'">
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <i class='fas fa-file'></i>
                  <span class="tab-title">Documents</span>
                </ng-template>
                <div class="row">
                  <div class="col-12">
                    <div *ngIf="isTrainingTypeLoading" class="text-center">
                      <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                    </div>
                    <div *ngIf="!isTrainingTypeLoading">
                      <app-documents-list [showCount]="true" [allowedOperations]="loggedInUser?.documentOperations"
                                          [headerText]="'Documents'"
                                          [addDocumentButtonText]="'Add'" [documents]="trainingTypeDocuments"
                                          [showTableCaption]="true" (viewDocument)="viewTrainingTypeDocument($event)"
                                          (downloadDocument)="downloadTrainingTypeDocument($event)"
                                          (deleteDocument)="deleteTrainingTypeDocumentClick($event)"
                                          (addDocument)="addTrainingTypeDocument()"
                                          (editDocument)="editTrainingTypeDocument($event)"
                                          (openDocument)="openTrainingTypeDocument($event)" (refreshDocumentsRequested)="getTrainingTypeDocuments($event)">
                      </app-documents-list>
                    </div>
                  </div>
                </div>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
